import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { TransformationSection } from './components/TransformationSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-zinc-300 font-sans selection:bg-gold-500/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedAttemptsSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <TransformationSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}